import React from 'react';
import styles from './BotPerformance.module.scss';
import RemainingTokens from './remaining-tokens/RemainingTokens';
import ResolutionRate from './resolution-rate/ResolutionRate';
import UserSatisfactionRate from './user-satisfaction-rate/UserSatisfactionRate';
import MostUsedWorkflow from './most-used-workflow/MostUsedWorkflow';
import MostUsedKnowledgeBase from './most-used-knowledge-base/MostUsedKnowledgeBase';

const BotPerformance = ({
  botId,
  startDate,
  endDate,
  snapshotMode = false,
  botType,
}) => {
  return (
    <div
      className={`${styles['bot-performance-container']} ${
        snapshotMode ? styles['snapshot-mode'] : ''
      }`}
    >
      {snapshotMode && (
        <RemainingTokens botId={botId} snapshotMode={snapshotMode} />
      )}
      <div
        className={`${styles['insights-container']} ${
          snapshotMode ? styles['snapshot-mode-2'] : ''
        }`}
      >
        {!snapshotMode && (
          <RemainingTokens botId={botId} snapshotMode={snapshotMode} />
        )}

        <div data-export='resolution-rate'>
          <ResolutionRate
            botId={botId}
            startDate={startDate}
            endDate={endDate}
            snapshotMode={snapshotMode}
            botType={botType}
          />
        </div>

        <div data-export='user-satisfaction-rate'>
          <UserSatisfactionRate
            botId={botId}
            startDate={startDate}
            endDate={endDate}
            botType={botType}
          />
        </div>
      </div>
      <div
        className={`${styles['usage-container']} ${
          snapshotMode ? styles['snapshot-mode'] : ''
        }`}
      >
        <div data-export='most-used-workflow'>
          <MostUsedWorkflow
            id={botId}
            startDate={startDate}
            endDate={endDate}
            botType={botType}
          />
        </div>

        <div data-export='most-used-knowledge-base'>
          <MostUsedKnowledgeBase
            id={botId}
            startDate={startDate}
            endDate={endDate}
            skipFetch={snapshotMode}
            botType={botType}
          />
        </div>
      </div>
    </div>
  );
};

export default BotPerformance;
